import React from 'react';
import styled from 'styled-components';
import { Color } from 'core';
import { ManualCreateSelectionCard } from './ManualCreateSelectionCard';
import { SmartCreateSelectionCard } from './SmartCreateSelectionCard';

interface CreateTypeSelectorProps {
  onManualCreateClick: () => void;
  onSmartCreateClick: () => void;
}

export const CreateTypeSelector = ({ onManualCreateClick, onSmartCreateClick }: CreateTypeSelectorProps) => {
  return (
    <>
      <SectionTitle>How would you like to create this?</SectionTitle>
      <CardsContainer>
        <ManualCreateSelectionCard onClick={onManualCreateClick} />
        <SmartCreateSelectionCard onClick={onSmartCreateClick} />
      </CardsContainer>
    </>
  );
};

const SectionTitle = styled.h3`
  text-align: center;
  color: ${Color.darkGray};
  margin: 0 0 40px 0;
  font-weight: 400;
  font-size: 20px;
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
`;
